<template>
  <span class="preview-light-popup-target"
    ><slot><FaIcon icon="preview"/></slot
  ></span>
</template>

<script>
import FaIcon from '@/components/ui/FaIcon'
import { MetaModelType } from '@/enums'

/**
 * Displays a content preview in a light popup when the component child(ren) is clicked.
 * Wraps over `edulab.components.contentsearch.PreviewLightPopup` to enable content previews without reimplementing it all in Vue.
 *
 * Example usage:
 * ```
 * <PreviewLightPopup :meta-model-type="MetaModelType.PDFASSIGNMENT" :content-id="item.id">
 *   <FaIcon icon="search" class="teacher-content-preview-icon" />
 *   {{ item.name }}
 * </LightPopup>
 * ```
 *
 * @author Thomas Grinderslev <lritgr@egmont.com>
 */
export default {
  name: 'PreviewLightPopup',
  components: { FaIcon },
  props: {
    metaModelType: {
      type: Number,
      required: true,
      validator: type => Object.values(MetaModelType).includes(type),
    },
    contentId: {
      type: Number,
      required: true,
      validator: id => id > 0,
    },
    name: {
      type: String,
      default: '',
    },
    showOnHover: {
      type: Boolean,
      default: false,
    },
    enableAddButton: {
      type: Boolean,
      default: false,
    },
    enablePrintButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /**
       * @type {edulab.components.contentsearch.PreviewLightPopup}
       */
      popupInstance: null,
    }
  },
  mounted() {
    this.popupInstance = edulab.pagescommon.books.Index.createPreviewLightPopupInstance(
      this.metaModelType,
      this.contentId,
      this.name,
      this.$el,
      this.showOnHover,
      this.enableAddButton,
      this.enablePrintButton
    )
  },
  beforeDestroy() {
    edulab.base.dispose(this.popupInstance)
  },
}
</script>
